// extracted by mini-css-extract-plugin
export default {"progressWrapper":"LoaderLayout_progressWrapper__flBST"};